import { Options,CustomStepDefinition, LabelType } from '@angular-slider/ngx-slider';
import { Component, EventEmitter, Input, OnChanges, OnInit, Output, SimpleChanges, ViewEncapsulation } from '@angular/core';
import { IntensityBucketEnum } from 'src/portal/search-api/models/intensity-bucket-enum';

@Component({
  selector: 'search-filter-slider-intensity',
  templateUrl: './search-filter-slider-intensity.component.html',
  styleUrls: ['./search-filter-slider-intensity.component.scss'],
  encapsulation: ViewEncapsulation.None,
})
export class SearchFilterSliderIntensityComponent implements OnChanges {

  @Input() selectedIntensity: IntensityBucketEnum | undefined;
  @Output() onChangeValue = new EventEmitter<IntensityBucketEnum>();

  sliderValue: number = 0;
  sliderOptions: Options = {
    floor: 0,
    ceil: 2,
    showTicks: true,
    showTicksValues:true,
    animate:true,
    rightToLeft: true,
    stepsArray: Object.values(IntensityBucketEnum).map((intensity: IntensityBucketEnum): CustomStepDefinition => {
      return { value: this.intensityToIndex(intensity) };
    }),
    translate: (value: number, label: LabelType): string => {
      const intensity = this.indexToIntensity(value);
      const capitalizedIntensity = intensity.charAt(0).toUpperCase() + intensity.slice(1).toLowerCase();
      return capitalizedIntensity;
    },
  };


  private intensityToIndex(intensity: IntensityBucketEnum): number {
    return Object.values(IntensityBucketEnum).indexOf(intensity);
  }

  private indexToIntensity(index: number): IntensityBucketEnum {
    return Object.values(IntensityBucketEnum)[index];
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes.selectedIntensity && this.selectedIntensity !== undefined) {
      this.sliderValue = this.getSliderValueFromIntensity(this.selectedIntensity);
    }
  }

  private getSliderValueFromIntensity(intensity: IntensityBucketEnum): number {
    switch (intensity) {
      case IntensityBucketEnum.LOW:
        return 0;
      case IntensityBucketEnum.MEDIUM:
        return 1;
      case IntensityBucketEnum.HIGH:
        return 2;
      default:
        return 0;
    }
  }

  public onIntensityChange(): void {
    this.onChangeValue.emit(this.indexToIntensity(this.sliderValue));
  }
}
